module.exports = __webpack_public_path__ + "static/media/undraw_3d_modeling_h60h.16868a34.png";